import classNames from 'classnames';

const FILLER_SPOT = { isFiller: true }
/**
 * Create fillers for when a user has not yet selected a cam for each cam slot
 * @param {Array<Object>} selectedSpots
 * @param {Number} numCams
 */
export const createFillers = (selectedSpots, numCams) => {
  const displayedSpots = selectedSpots.map(spot => spot || FILLER_SPOT).slice(0, numCams);
  const filler = Array(numCams - displayedSpots.length).fill(FILLER_SPOT);
  return [...displayedSpots, ...filler];
};

/**
 * Creates class names for the multi cam component
 * @param {Number} numCams
 * @param {Boolean} timeout
 * @param {Boolean} showCamTimeout
 * @param {Boolean} isPaywalled
 * @param {Boolean} isPlayingAd
 */
export const multiCamClass = (numCams, timeout, showCamTimeout, isPaywalled, isPlayingAd) =>
classNames({
  'sl-multi-cam__cams': true,
  'sl-multi-cam__cams--timed-out': timeout && showCamTimeout && !isPaywalled,
  'sl-multi-cam__cams--no-timeout': !showCamTimeout || isPaywalled,
  'sl-multi-cam__cams--single': numCams === 1,
  'sl-multi-cam__cams--double': numCams === 2,
  'sl-multi-cam__cams--triple': numCams === 3,
  'sl-multi-cam__cams--quad': numCams === 4,
  'sl-multi-cam__cams--nintuple': numCams === 9,
  'sl-multi-cam__cams--ad': !!isPlayingAd,
});

/**
 * Creates class names for the multi cam container
 * @param {Boolean} isPlayingAd
 * @param {Boolean} showUpSell
 */
export const multiCamContainerClass = (isPlayingAd, showUpSell) =>
  classNames({
    'sl-multi-cam-container': true,
    'sl-multi-cam-container--ad': isPlayingAd,
    'sl-multi-cam-container--upsell': showUpSell,
  });
